import { AccountFlagEnum } from '~/generated/graphql';
import { useFeatureFlag } from '~/hooks/account';

function useVisitorReport() {
  const { enabled: reportEnabled, loading: loadingReport } = useFeatureFlag(
    AccountFlagEnum.VisitorReportInPlatform,
  );

  const { enabled: internal, loading: loadingInternal } = useFeatureFlag(
    AccountFlagEnum.XClearbitInternal,
  );

  return {
    enabled: reportEnabled || internal,
    loading: loadingReport || loadingInternal,
  };
}

export default useVisitorReport;
